import { __decorate } from "tslib";
import { customElement, html } from '@microsoft/fast-element';
import { commonLoginRouteStyles } from '../../styles';
import { BaseRoute } from '../base';
let NotFound = class NotFound extends BaseRoute {
};
NotFound = __decorate([
    customElement({
        name: 'foundation-login-not-found',
        template: html `
    <h1 data-test-id="not-found">Not found! 404</h1>
  `,
        styles: commonLoginRouteStyles,
    })
], NotFound);
export { NotFound };
